<!--Author: Michał Pawłowski-->
<template>
  <div class="slv-container">
    <header
        v-if="title !== undefined && true && title.length > 0"
        class="slv-header"
    >
      <span class="slv-header-title">{{ title }}</span>
    </header>

    <nav class="slv-body" aria-label="Scrollable list">
      <ul
          class="slv-list list-group internal-placement"
          :style="ulStyle"
          role="listbox"
      >

        <li
            v-for="(li, index) in list"
            :key="li + '-' + index"
            class="slv-item list-group-item"
            role="option"
            :title="li"
            tabindex="0"
        >
          <span class="slv-bullet" aria-hidden="true"></span>
          <span class="slv-text">{{ li }}</span>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "ScrollableListView",
  props: {
    title: String,
    listContent: String,
    ulStyle: { type: String, default: "" },
  },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    listContent: {
      handler() {
        if (this.listContent != null) {
          this.list = this.listContent.toString().split(";");
          if (this.list === undefined || this.list == null) {
            this.list = [];
          }
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.listContent != null) {
      this.list = this.listContent.toString().split(";");

      if (this.list === null) {
        this.list = [];
      }else{
        this.list = this.list.filter(item => item.trim() !== "");
      }
    }
  },
};
</script>
<style scoped>
.slv-container {
  display: flex;
  flex-direction: column;
  border: 1px solid #d7d7d7;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  overflow: hidden;
}

/* Header */
.slv-header {
  display: flex;
  align-items: center;
  min-height: 20px;
  padding: 4px 12px;
  background: linear-gradient(180deg, #f7f7f7, #efefef);
}

.slv-header-title {
  font-weight: 600;
  font-size: 14px;
  color: #2b2b2b;
}

/* Body */
.slv-body {
  padding: 8px;
}

/* List wrapper */
.slv-list {
  /* keep original behavior but slightly taller by default (easily overridden via :style) */
  height: 200px;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background: #fafafa;
  overflow: hidden;
  overflow-y: auto;
}

/* Custom scrollbar (WebKit) */
.slv-list::-webkit-scrollbar {
  width: 10px;
}
.slv-list::-webkit-scrollbar-track {
  background: #f2f2f2;
  border-left: 1px solid #e6e6e6;
}
.slv-list::-webkit-scrollbar-thumb {
  background: #cfcfcf;
  border-radius: 8px;
  border: 2px solid #f2f2f2;
}
.slv-list::-webkit-scrollbar-thumb:hover {
  background: #bdbdbd;
}

/* Firefox scrollbar */
.slv-list {
  scrollbar-width: thin;
  scrollbar-color: #cfcfcf #f2f2f2;
}

/* Individual items */
.slv-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  border: none;                /* neutralize bootstrap's borders */
  border-bottom: 1px solid #ebebeb;
  background: transparent;
  font-size: 13px;
  color: #1f1f1f;
}

.slv-item:last-child {
  border-bottom: none;
}

/* Hover/focus for keyboard + mouse */
.slv-item:hover {
  background: #eef5ff;
}
.slv-item:focus {
  outline: none;
  background: #e2efff;
  box-shadow: inset 0 0 0 2px #d0e6ff;
  border-radius: 6px;
}

/* Small bullet to visually align items */
.slv-bullet {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6b6b6b;
  opacity: 0.55;
  flex: 0 0 auto;
}

.slv-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Keep your original helper class but tone it to a subtle Windows-like tint */
.internal-placement {
  padding: 8px;
  background-color: #f7f9fc;
  border-radius: 8px;
}
</style>
